/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { StoreModule, Action } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SharedModule } from 'app/shared/shared.module';
import { StaticDataEffects } from './store/static-data.effects';
import { NgModule } from '@angular/core';
import { RestClientService } from 'app/shared/services/rest-client.service';
import { DataService } from './services/data.service';
import { environment } from 'environments/environment';
import { MockDataService } from './services/mock-data.service';
import { ApiDataService } from './services/api-data.service';
import { StaticDataState, INITIAL_STATE } from './store/static-data.state';
import { flattenReducers } from 'app/shared/store/utils';
import { reducer } from './store/static-data.reducers';
import { NameOverridingDataService } from 'app/static-data/services/name-overriding.data.service';

@NgModule({
  imports: [
    SharedModule,
    StoreModule.forFeature('static-data', staticDataReducer),
    EffectsModule.forFeature([StaticDataEffects])
  ],
  providers: [{ provide: DataService, useFactory: dataServiceFactory, deps: [RestClientService] }]
})
export class StaticDataModule {}

/** The flattened reducer for the static data state. */
export function staticDataReducer(state: StaticDataState, action: Action): StaticDataState {
  return flattenReducers(INITIAL_STATE, reducer)(state, action);
}

/** Provides the data service. */
export function dataServiceFactory(restClientService: RestClientService): DataService {
  let dataService;
  if (environment.dataProvider === 'mock') {
    dataService = new MockDataService();
  } else {
    dataService = new ApiDataService(restClientService);
  }
  return new NameOverridingDataService(dataService);
}
